import { getSrc } from '../../utils';
import brightpearl from './brightpearl.png';
import cin7 from './cin7.png';
import intuitiveShipping from './intuitive-shipping.png';
import katana from './katana.png';
import linnworks from './linnworks.png';
import quickbooks from './quickbooks.png';
import sufio from './sufio.png';
import unleashed from './unleashed.png';
import xero from './xero.png';

export type PartnerLogoName =
  | 'brightpearl'
  | 'cin7'
  | 'intuitive-shipping'
  | 'katana'
  | 'linnworks'
  | 'quickbooks'
  | 'sufio'
  | 'unleashed'
  | 'xero';

const LOGOS: Record<PartnerLogoName, string> = {
  brightpearl: getSrc(brightpearl),
  cin7: getSrc(cin7),
  'intuitive-shipping': getSrc(intuitiveShipping),
  katana: getSrc(katana),
  linnworks: getSrc(linnworks),
  quickbooks: getSrc(quickbooks),
  sufio: getSrc(sufio),
  unleashed: getSrc(unleashed),
  xero: getSrc(xero),
};

export function getPartnerLogo(name: PartnerLogoName): string {
  return LOGOS[name];
}
